import { useCallback, useEffect, useRef, useState } from "react";
import { useFrame } from "@react-three/fiber";
import { useProgress } from "@react-three/drei";

import LoaderLetterReveal from "../LoaderLetterReveal/LoaderLetterReveal";
import gsap from "gsap";
import s from "./Loader.module.scss";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import { useStore } from "../../store/store";

const Loader = () => {
  const { active, progress, errors, item, loaded, total } = useProgress();
  const lenis = useStore((state) => state.lenis);
  const loaderRef = useRef();

  const progressRef = useRef(0);
  const targetProgressRef = useRef(0);
  const finalProgress = useRef(0);

  const setLoadingProgress = useStore((state) => state.setLoadingProgress);
  const setLoadingScreen = useStore((state) => state.setLoadingScreen);

  useEffect(() => {
    gsap.ticker.add(updateProgress);

    return () => {
      gsap.ticker.remove(updateProgress);
    };
  }, []);

  useEffect(() => {
    targetProgressRef.current = progress;
  }, [progress]);

  const updateProgress = useCallback((time, delta) => {
    progressRef.current = gsap.utils.interpolate(
      progressRef.current,
      targetProgressRef.current,
      0.2
    );

    // do this because sometimes progress is recalculated and it rollbacks the animation linked
    if (progressRef.current > finalProgress.current) {
      finalProgress.current = progressRef.current;
    }
    // set the value in the store
    setLoadingProgress(finalProgress.current * 0.01);

    if (Math.round(finalProgress.current) === 100) {
      gsap.ticker.remove(updateProgress);
      setLoadingProgress(1);
    }
  }, []);

  const hideLoader = () => {
    ScrollTrigger.refresh();

    gsap.to(loaderRef.current, {
      opacity: 0,
      duration: 0.5,
      onComplete: () => {
        lenis.start();
        setLoadingScreen(false);
        document.body.style.overflowY = "visible";
      },
    });
  };

  return (
    <div id="loader" ref={loaderRef} className={s.loader}>
      <div className={s.loading}>
        <LoaderLetterReveal onComplete={hideLoader}>LOADING</LoaderLetterReveal>
      </div>
    </div>
  );
};

export default Loader;
